import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import FileSaver from 'file-saver'

import { downloadInvoicesReport } from 'Services/JOONAdmin/joonAdminReportsService'

import { QueryNames } from 'Hooks/api/queryNames'

import { AppNotification } from 'Utils/types/appNotification'
import { buildExcelFileBlob } from 'Utils/helpers/files'
import { Employer } from 'Utils/types/JOONAdmin/employer'
import { formatDateForServer } from 'Utils/helpers/dateUtils'

const invoicesReportFilename = (employerId: number, employerName: string, date: string) => {
  const sanitizedEmployerName = employerName.replace(/[^a-zA-Z0-9]+/g, '_')
  return `employer_${employerId}_${sanitizedEmployerName}_invoices_report_${date}.zip`
}

export const useDownloadInvoicesReport = () =>
  useMutation(
    [QueryNames.DownloadInvoicesReport],
    async ({
      employerId,
      employerName,
      reportDate
    }: {
      employerId: Employer['id']
      employerName: Employer['name']
      reportDate: Date
    }) => {
      const dateString = formatDateForServer(reportDate)
      const response = await downloadInvoicesReport(employerId, dateString)
      if (response.data) {
        FileSaver.saveAs(
          buildExcelFileBlob(response.data),
          invoicesReportFilename(employerId, employerName, dateString)
        )
        toast.success(AppNotification.ReportDownloadSuccess)
      } else {
        toast.error(response.message || AppNotification.ReportDownloadFailure)
      }
    },
    {
      onError: () => {
        toast.error(AppNotification.ReportDownloadSuccess)
        return undefined
      }
    }
  )
